import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../components/common/Button'; 
import { useWallet } from '../contexts/WalletContext';
import { ArrowRightIcon, SparklesIcon, UserGroupIcon, PlusCircleIcon } from '@heroicons/react/24/outline'; 

const HomePage = () => {
  const { currentAccount } = useWallet();

  const quickActions = [
    { name: 'View My Agents', href: '/my-agents', icon: UserGroupIcon, variant: 'primary', requiresAccount: true },
    { name: 'Create New Agent', href: '/create-agent', icon: PlusCircleIcon, variant: 'secondary', requiresAccount: true },
    // { name: 'Discover Agents', href: '/discover', icon: SparklesIcon, variant: 'ghost' }, 
  ];

  return (
    <div className=" p-6 md:p-10 lg:p-12">
      <div className="text-center">
        <div className="mb-8">
          <SparklesIcon className="h-16 w-16 sm:h-20 sm:w-20 text-blue-400 mx-auto mb-4" />
          <h1 className="text-3xl
          h-16 sm:h-25 
          sm:text-4xl md:text-5xl font-bold text-transparent bg-clip-text
           bg-gradient-to-r from-blue-400 via-blue-500 to-pink-500 mb-4">
            AI Agent Marketplace
          </h1>
          <p className="text-md sm:text-lg text-slate-300 mb-10 max-w-2xl mx-auto mt-3">
            Welcome! Discover, create, and deploy powerful AI agents tailored to your needs.
            Connect your wallet to unlock the full potential and manage your creations.
          </p>
        </div>

        {currentAccount ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-lg mx-auto">
            {quickActions.filter(action => action.requiresAccount).map((action) => (
              <Link to={action.href} key={action.name}>
                <Button
                  size="lg"
                  variant={action.variant || 'primary'}
                  className="w-full flex items-center justify-center !py-3 text-base" // !py-3 untuk override
                >
                  <action.icon className="h-5 w-5 mr-2.5" />
                  {action.name}
                </Button>
              </Link>
            ))}
          </div>
        ) : (
          <div className="max-w-md mx-auto">
            <p className="text-md text-slate-400 mb-6">
              Connect your wallet using the button in the navbar to get started and manage your AI agents.
            </p>
            {/* <ConnectWalletButton /> */}
          </div>
        )}
      </div>

      <div className="mt-12 sm:mt-16 pt-8 sm:pt-10 border-t border-slate-700/50">
        <h2 className="text-2xl sm:text-3xl font-semibold text-slate-100 mb-6 sm:mb-8 text-center">
          Explore Possibilities
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-slate-800/80 backdrop-blur-sm border border-slate-700 p-6 rounded-lg shadow-lg hover:shadow-blue-500/20 transition-shadow">
            <SparklesIcon className="h-8 w-8 text-blue-400 mb-3" />
            <h3 className="text-lg font-semibold text-slate-100 mb-2">Powerful AI Models</h3>
            <p className="text-sm text-slate-300">
              Access a wide range of AI models ready to be customized and deployed for various tasks.
            </p>
          </div>
          <div className="bg-slate-800/80 backdrop-blur-sm border border-slate-700 p-6 rounded-lg shadow-lg hover:shadow-blue-500/20 transition-shadow">
            <PlusCircleIcon className="h-8 w-8 text-green-400 mb-3" />
            <h3 className="text-lg font-semibold text-slate-100 mb-2">Create Your Own</h3>
            <p className="text-sm text-slate-300">
              Easily define and configure your custom AI agents with a user-friendly interface.
            </p>
          </div>
          <div className="bg-slate-800/80 backdrop-blur-sm border border-slate-700 p-6 rounded-lg shadow-lg hover:shadow-blue-500/20 transition-shadow">
            <UserGroupIcon className="h-8 w-8 text-blue-400 mb-3" />
            <h3 className="text-lg font-semibold text-slate-100 mb-2">Manage & Deploy</h3>
            <p className="text-sm text-slate-300">
              Keep track of your agents, monitor their usage, and prepare them for various applications.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;